/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LatestGovernmentForum.vue?vue&type=template&id=e3ae23ba&scoped=true&"
import script from "./LatestGovernmentForum.vue?vue&type=script&setup=true&lang=js&"
export * from "./LatestGovernmentForum.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./LatestGovernmentForum.vue?vue&type=style&index=0&id=e3ae23ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ae23ba",
  null
  
)

export default component.exports